var Marionette = require('backbone.marionette');
var CommonUtils = require('../../utils/common-utils.js');
var RemoteSuggesterView = require('../common/remote-suggester-input.js');
var SnomedTreeView = require('./snomed-tree-view.js');

var Radio = require('backbone.radio');
var notificationsChannel = Radio.channel('notifications');

var utils = new CommonUtils();

var MedicationForm = Marionette.View.extend({
        template: require('../../templates/medicals/medication-form.html'),

        regions: {
            searchTextContainer: '#search-text-container',
            snomedTree: '#snomed-tree'
        },

        ui: {
            formModal: '#medication-form-modal',
            save: '#save',
            name: '#name',
            diseases: '#diseases',
            eventType: '#event',
            form: '#form',
            formcode: '#formcode',
            dose: '#dose',
            dosecode: '#dosecode',
            quantity: '#quantity',
            frequency: '#frequency',
            continuousFrequencyContainer: '#continuous-frequency-container',
            startDate: '#start-date',
            stopDate: '#stop-date',
            documents: '#documents',
            comment: '#comment',

            searchButton: '#search-button',
            searchResultsTable: '#search-results',

            continuousFrequencyFelected: "#continuous-frequency-selected",
            continuousFrequencyFelectedValue: "#continuous-frequency-selected-value",
            snomedTree: '#snomed-tree',

            leftSide: '.inputs'
        },

        events: {
            'click @ui.save': 'saveMedication',
            'keypress @ui.quantity': 'allowOnlyInts',
            'change @ui.frequency': 'onFrequencyChanged',
            'keyup input[required]': 'validate',
            'change input[required]': 'validate',
            'click @ui.searchButton': 'search',
            'click #continuous-frequency-remove': 'removeContinuousFrequency'
        },

        templateContext: function () {
            var that = this;
            return {
                title: that.mode == 'add' ? 'Add medication' : 'Edit medication',
                forms: that.defaultMedicationForms,
                eventType: that.medication.eventType,
                mode: that.mode,
                name: that.medication.name,
                form: (that.medication.formObj || {}).title || "",
                dose: (that.medication.doseObj  || {}).title  || "",
                quantity: that.medication.quantity,
                frequency: that.medication.frequency,
                continuousFrequency: that.medication.regularFrequency,
                startDate: (that.medication.startDate == '' || that.medication.startDate == null || that.medication.startDate == 0
                    ? '' : utils.longToDateTimeFormatted(Number(that.medication.startDate), 'MM/DD/YYYY')),
                stopDate: (that.medication.stopDate == '' || that.medication.stopDate == null || that.medication.stopDate == 0
                    ? '' : utils.longToDateTimeFormatted(Number(that.medication.stopDate), 'MM/DD/YYYY')),
                comment: that.medication.comment,
                eventTypes: that.getMedicationEventTypes().map(function(et) {
                    return {
                        id: et,
                        name: utils.getMedicationEventType(et)
                    }
                }),
                isNewGroup: that.isNewGroup,
                getBaseInitialMedicationEventType: that.getBaseInitialMedicationEventType
            };
        },

        initialize: function (options) {
            _.bindAll(this, 'onRender', 'showModal', 'hideModal', 'saveMedication', 'allowOnlyInts', 'allowOnlyFloats',
                'fillMedication', 'validate', 'search', 'tranformSnomedResponse', 'tranformCustomResponse', 'renderResultInTable',
                'fillFormFromSelectedResult', 'showLoading', 'hideLoading', 'getMedicationEventTypes',
                'showDefaultOptionsOfMedicationFormsSelect', 'showRxNormOptionsOfMedicationFormsSelect',
                'clearAndAddMedicationFormsOptions', 'removeMedicationFormsOptions', 'resetDoseSelect', 'fillDoseSelectFromRxNorm',
                'onFrequencyChanged', 'onChildviewNodeSelected', 'removeContinuousFrequency');
            if (options) {
                this.mode = options.mode;
                this.medication = options.medication;
                this.servicesAddresses = options.servicesAddresses;
                this.isNewGroup = options.isNewGroup;
                this.diseases = options.diseases || [];
                this.defaultMedicationForms = options.defaultMedicationForms;
                this.documents = options.documents;
            }
            this.utils = new CommonUtils();
            this.results = [];
            this.searchTextInputId = 'search-text';
        },

        listDelimeter: '~',

        onRender: function () {
            var that = this;

            that.showChildView('snomedTree', new SnomedTreeView({
                parent: '307430002',
                showHead: false
            }));

            that.documentsSelect = that.ui.documents.selectize({
                plugins: ['remove_button'],
                inputClass: 'selectize-input normal-width selectized',
                valueField: 'id',
                labelField: 'name',
                sortField: 'name',
                placeholder: "Select documents",
                options: that.documents,
                items: that.medication.documentsIds,
                delimiter: that.listDelimeter,
                highlight: true,
                openOnFocus: true,
                render: {
                    item: function(data, escape) {
                        return '<div class="item"><a href="/#document/' + escape(data.id) + '" target="_blank">'
                            + escape(data.name) + '</a></div>';
                    }
                }
            });

            that.formsSelect = that.ui.form.selectize({
                allowEmptyOption: false
            });

            that.doseSelect = that.ui.dose.selectize({
                create: true
            });

            that.frequencySelect = that.ui.frequency.selectize({
                allowEmptyOption: true
            });

            try {
                that.ui.eventType.selectize({
                    allowEmptyOption: false
                })[0].selectize.on('change', function (id) {
                    that.validate();
                });
            } catch (e) {
            }


            var diseasesSelect = that.ui.diseases.selectize({
                plugins: ['remove_button'],
                inputClass: 'selectize-input normal-width selectized',
                valueField: 'uuid',
                labelField: 'name',
                placeholder: "Select diseases",
                options: that.diseases,
                items: that.medication.diseasesUuids,
                delimiter: that.listDelimeter,
                highlight: true,
                openOnFocus: true
            });

            this.showModal();
            this.ui.save.attr('disabled', true);
            this.ui.searchResultsTable.hide();

            this.ui.startDate.datepicker({
                format: 'mm/dd/yyyy',
                clearBtn: true
            }).on('changeDate', function (e) {
                $(this).datepicker('hide');
            });
            this.ui.stopDate.datepicker({
                format: 'mm/dd/yyyy',
                clearBtn: true
            }).on('changeDate', function (e) {
                $(this).datepicker('hide');
            });

            if (this.mode == 'edit') {
                this.ui.leftSide.removeClass('col-md-6');
                this.ui.leftSide.addClass('col-md-11');
            }

            if (this.medication.medicationId != undefined && this.medication.medicationId != '') {
                if (this.medication.systemType == 'RxNorm') {
                    this.showRxNormOptionsOfMedicationFormsSelect(this.medication.medicationId, this.removeMedicationFormsOptions);
                    this.fillDoseSelectFromRxNorm(this.medication.medicationId);
                } else {
                    this.resetDoseSelect();
                }
            }

            this.validate();

            if (this.mode == 'add') {
                this.showChildView('searchTextContainer', new RemoteSuggesterView({
                    inputId: this.searchTextInputId,
                    url: that.servicesAddresses["rxnormMedicationServiceAddress"] + '/REST/spellingsuggestions.json?name=~~~',
                    symbolForSearchInUrl: '~~~',
                    listLocation: function (data) {
                        return (data.suggestionGroup.suggestionList || {suggestion: []}).suggestion;
                    },
                    getValueFn: function (element) {
                        return element;
                    },
                    classes: ["form-control"],
                    placeholder: "For search type at least 2 character"
                }));
            }
        },

        showModal: function () {
            this.ui.formModal.modal("show");
        },

        hideModal: function () {
            this.ui.formModal.modal("hide");
        },

        saveMedication: function () {
            if (this.mode == 'add')
                this.triggerMethod('new:medication', this.fillMedication());
            else if (this.mode == 'edit')
                this.triggerMethod('update:medication', this.fillMedication());

            this.hideModal();
        },

        fillMedication: function () {
            if (this.isNewGroup) {
                this.medication.groupUuid = this.utils.generatedUUID();
            }
            this.medication.medicationUuid = this.utils.generatedUUID();
            this.medication.medicationId = typeof this.medication.medicationId == "undefined" ?
                Math.round(Math.random() * 100000) : this.medication.medicationId;
            this.medication.name = this.ui.name.val();


            this.medication.formObj = {
                title: $("#form option:selected").text(),
                code: this.ui.form.val(),
                systemId: 'RxNorm'
            };

            this.medication.eventType =
                this.isNewGroup || this.medication.eventType == this.getBaseInitialMedicationEventType()
                    ? this.getBaseInitialMedicationEventType() : this.ui.eventType.val();


            this.medication.doseObj= {
                title: this.ui.dose.val(),
                code: this.ui.dose.val(),
                systemId: 'RxNorm'
            };

            this.medication.quantity = this.ui.quantity.val();

            this.medication.frequency = {
                systemId: 'snomed',
                code: this.ui.frequency.val(),
                title: this.ui.frequency.children(':selected')[0].text
            };

            this.medication.startDate = this.utils.dateToLong(this.ui.startDate.val());
            this.medication.stopDate = this.utils.dateToLong(this.ui.stopDate.val());
            this.medication.comment = this.ui.comment.val();
            this.medication.diseasesUuids = (this.ui.diseases.val().split(this.listDelimeter) || [])
                .filter(function(diseaseUuid) {
                    return diseaseUuid != "";
                });
            this.medication.documentsIds = (this.ui.documents.val().split(this.listDelimeter) || [])
                .filter(function(id) {
                    return id != "";
                });

            if (this.continuousFrequency){
                this.medication.regularFrequency = this.continuousFrequency;
            }

            if ((this.medication.frequency || {}).code !== '255238004'){
                this.medication.regularFrequency = undefined;
            }
            return this.medication;
        },

        allowOnlyFloats: function (event) {
            return event.charCode == 46 || this.allowOnlyInts(event);
        },

        allowOnlyInts: function (event) {
            return event.keyCode == 8 || event.keyCode == 46 || event.keyCode == 37 || event.keyCode == 39 ||
                event.charCode >= 48 && event.charCode <= 57;
        },

        validate: function () {
            if (this.ui.name.val() != '' && this.ui.quantity.val() != '') {
                this.ui.save.removeAttr('disabled');
            } else {
                this.ui.save.attr('disabled', true);
            }

            try {
                if (this.ui.eventType.val() == '') {
                    this.ui.save.attr('disabled', true);
                }
            } catch (exp) {
            }

        },

        search: function (event) {
            var searchText = $('#' + this.searchTextInputId).val();
            if (searchText.length < 2)
                return;
            $('#search-results tr:not(:first)').remove();
            var that = this;
            if (event.keyCode == 13 || event.target.id == that.ui.searchButton.attr('id')) {
                this.results = [];
                that.showLoading();
                //var isSnomedRequestComplete = false;
                var isCustomRequestComplete = false;
                var isRxnormRequestComplete = false;

                /*if (typeof that.servicesAddresses["snomedMedicationServiceAddress"] != "undefined") {
                 $.when(
                 $.ajax({
                 type: "GET",
                 url: that.servicesAddresses["snomedMedicationServiceAddress"] +
                 '/descriptions?returnLimit=100&semanticFilter=product&query=' + searchText
                 })
                 ).done(function (resp) {
                 that.renderResultInTable(that.tranformSnomedResponse(resp));
                 isSnomedRequestComplete = true;
                 if (isSnomedRequestComplete && isCustomRequestComplete)
                 that.hideLoading();
                 }).fail(function (jqXHR, textStatus) {
                 notificationsChannel.request('show:notification', "Error. Snomed medication service is unavailable");
                 isSnomedRequestComplete = true;
                 if (isSnomedRequestComplete && isCustomRequestComplete)
                 that.hideLoading();
                 });
                 } else isSnomedRequestComplete = true;*/

                if (typeof that.servicesAddresses["rxnormMedicationServiceAddress"] != "undefined") {
                    $.when(
                        $.ajax({
                            type: "GET",
                            headers: {
                                Accept: 'application/json'
                            },
                            url: that.servicesAddresses["rxnormMedicationServiceAddress"] +
                            '/REST/drugs.json?name=' + searchText
                        })
                    ).done(function (resp) {
                        var transformed = that.tranformRxNormResponse(resp);
                        if (transformed.length == 0) {
                            that.showDefaultOptionsOfMedicationFormsSelect();
                            that.resetDoseSelect();
                        }
                        that.renderResultInTable(transformed);
                        isRxnormRequestComplete = true;
                        if (isRxnormRequestComplete && isCustomRequestComplete)
                            that.hideLoading();
                    }).fail(function (jqXHR, textStatus) {
                        notificationsChannel.request('show:notification', "Error. RxNorm medication service is unavailable");
                        isRxnormRequestComplete = true;
                        if (isRxnormRequestComplete && isCustomRequestComplete)
                            that.hideLoading();
                    });
                } else isRxnormRequestComplete = true;

                if (typeof that.servicesAddresses["customMedicationServiceAddress"] != "undefined") {
                    $.when(
                        $.ajax({
                            type: "GET",
                            url: that.servicesAddresses["customMedicationServiceAddress"] +
                            '/api/medications?name=' + searchText
                        })
                    ).done(function (resp) {
                        that.renderResultInTable(that.tranformCustomResponse(resp));
                        isCustomRequestComplete = true;
                        if (isRxnormRequestComplete && isCustomRequestComplete)
                            that.hideLoading();
                    }).fail(function (jqXHR, textStatus) {
                        notificationsChannel.request('show:notification', "Error. Custom medication service is unavailable");
                        isCustomRequestComplete = true;
                        if (isRxnormRequestComplete && isCustomRequestComplete)
                            that.hideLoading();
                    });
                } else isCustomRequestComplete = true;
            }
        },

        tranformSnomedResponse: function (response) {
            return (response.matches || []).map(function (item) {
                return {
                    id: item.conceptId,
                    name: item.term,
                    systemType: 'Snomed'
                }
            });
        },

        tranformCustomResponse: function (response) {
            return (response || []).map(function (item) {
                return {
                    id: item.id,
                    name: item.name,
                    systemType: 'Custom'
                }
            });
        },

        onFrequencyChanged: function(){
            if (this.ui.frequency.val() == '255238004'){
                this.ui.continuousFrequencyContainer.show();
            } else {
                this.ui.continuousFrequencyContainer.hide();
            }
            this.validate()
        },

        tranformRxNormResponse: function (response) {
            var sbd = (response.drugGroup.conceptGroup || []).filter(function (group) {
                return group.tty == 'SBD' || group.tty == 'SCD';
            });

            if (sbd.length == 0) return [];

            return (sbd[0].conceptProperties || []).map(function (group) {
                return {
                    id: group.rxcui,
                    name: group.name,
                    systemType: 'RxNorm'
                }
            });
        },

        renderResultInTable: function (results) {
            var that = this;
            that.results = that.results.concat(results);
            results = _.sortBy(results, 'name');

            results.forEach(function (item) {
                var newRowContent = "<tr class='clickable' id='" + item.id + "'><td>"
                    + item.name + "</td><td>" + item.systemType + "</td>";
                $('#search-results tbody').append(newRowContent);
            });

            $("#search-results tr:not(:first)").on('click', function (event) {
                var id = event.currentTarget.id;
                $(this).addClass('selected').siblings().removeClass('selected');
                that.fillFormFromSelectedResult(id, that.results);
            });
            if (results.length > 0) {
                this.ui.searchResultsTable.show();
            }
        },

        fillFormFromSelectedResult: function (selectedId, results) {
            var selected = _.findWhere(results, {id: selectedId});
            if (selected.systemType == 'RxNorm') {
                this.showRxNormOptionsOfMedicationFormsSelect(selected.id, this.clearAndAddMedicationFormsOptions, true);
                this.fillDoseSelectFromRxNorm(selected.id);
            } else {
                this.showDefaultOptionsOfMedicationFormsSelect();
                this.resetDoseSelect();
            }
            this.medication.systemType = selected.systemType;
            this.medication.medicationId = selected.id;
            this.medication.name = selected.name;
            this.ui.name.val(selected.name);
            this.validate();
        },

        clearAndAddMedicationFormsOptions: function (obj) {
            var that = this;
            (_.sortBy(obj.conceptProperties, "name") || []).forEach(function (concept, index) {
                that.formsSelect[0].selectize.addOption({
                    value: concept.rxcui,
                    text: concept.name
                });
                if (index == 0) {
                    that.formsSelect[0].selectize.addItem(concept.rxcui);
                }
            });
        },

        removeMedicationFormsOptions: function (obj) {
            var that = this;
            Object.keys(that.formsSelect[0].selectize.options).forEach(function (id) {
                var found = _.findWhere(_.sortBy(obj.conceptProperties, "name"), {rxcui: id});
                if (found == undefined) {
                    that.formsSelect[0].selectize.removeOption(id);
                }
            });
        },

        showDefaultOptionsOfMedicationFormsSelect: function () {
            var that = this;
            that.formsSelect[0].selectize.clearOptions();
            that.defaultMedicationForms.forEach(function (form) {
                that.formsSelect[0].selectize.addOption({
                    value: form.id,
                    text: form.name
                });
            });
        },

        showRxNormOptionsOfMedicationFormsSelect: function (rxcui, handler, clearAllOptions) {
            var that = this;
            if (clearAllOptions) {
                that.formsSelect[0].selectize.clearOptions();
            }
            $.when(
                $.ajax({
                    type: "GET",
                    headers: {
                        Accept: 'application/json'
                    },
                    url: that.servicesAddresses["rxnormMedicationServiceAddress"] + '/REST/rxcui/' + rxcui + '/related.json?tty=DFG'
                })
            ).done(function (response) {
                var dfg = (response.relatedGroup.conceptGroup || []).filter(function (group) {
                    return group.tty == 'DFG';
                });

                if (dfg.length > 0) {
                    handler(dfg[0]);
                }
            }).fail(function (jqXHR, textStatus) {
                notificationsChannel.request('show:notification', "Error. RxNorm medication service is unavailable");
            });
        },

        resetDoseSelect: function () {
            var that = this;
            that.doseSelect[0].selectize.clearOptions();
            if (that.medication.dose != undefined) {
                that.doseSelect[0].selectize.addOption({
                    value: that.medication.dose,
                    text: that.medication.dose
                });
                that.doseSelect[0].selectize.addItem(that.medication.dose);
            }
        },

        fillDoseSelectFromRxNorm: function (rxcui) {
            var that = this;
            that.resetDoseSelect();

            $.when(
                $.ajax({
                    type: "GET",
                    headers: {
                        Accept: 'application/json'
                    },
                    url: that.servicesAddresses["rxnormMedicationServiceAddress"]
                    + '/REST/rxcui/' + rxcui + '/property.json?propName=AVAILABLE_STRENGTH'
                })
            ).done(function (response) {
                (response.propConceptGroup.propConcept || []).forEach(function (concept, index) {
                    that.doseSelect[0].selectize.addOption({
                        value: concept.propValue,
                        text: concept.propValue
                    });
                    if (index == 0 && that.medication.dose == undefined || concept.propValue == that.medication.dose) {
                        that.doseSelect[0].selectize.addItem(concept.propValue);
                    }
                });
            }).fail(function (jqXHR, textStatus) {
                notificationsChannel.request('show:notification', "Error. RxNorm medication service is unavailable");
            });
        },

        getMedicationEventTypes: function () {
            return ["ANOTHER_APPOINTMENT", "PURCHASE", "TAKEN_INSIDE"];
        },

        getBaseInitialMedicationEventType: function () {
            return "PRESCRIPTION";
        },

        showLoading: function () {
            this.utils.showSpinner('#medication-loader');
        },

        hideLoading: function () {
            this.utils.hideSpinner('#medication-loader');
        },

        onChildviewNodeSelected: function (element) {
            this.ui.continuousFrequencyFelectedValue.html(element.text);
            this.ui.continuousFrequencyFelected.show();
            this.ui.snomedTree.hide();
            this.continuousFrequency = {
                systemId: 'snomed',
                code: element.conceptId,
                title: element.text
            }
        },

        removeContinuousFrequency: function () {
            this.ui.continuousFrequencyFelectedValue.html('');
            this.ui.continuousFrequencyFelected.hide();
            this.ui.snomedTree.show();
            this.continuousFrequency = undefined;
        }

    })
    ;

module.exports = MedicationForm;


//////////////////
// WEBPACK FOOTER
// ./app/views/medicals/medication-form.js
// module id = 348
// module chunks = 0